// extracted by mini-css-extract-plugin
export var deleteModal = "_rh-0";